import * as Yup from "yup";

import React, { useState } from "react";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { resetPassword } from "../_redux/authCrud";
import PasswordInput from "../components/PasswordInput";
import PasswordStrengthMeter from "../components/PasswordStrengthMeter";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useFormik } from "formik";

const strongPasswordPattern =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

const LoginWrapper = styled.div`
    position: absolute;
    top: 65%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    background: rgba(30, 30, 45, 0.8);
    color: #fff;
    padding: 1rem;
    width: 40vw;
    min-width: 300px;
    max-width: 400px;
    border-radius: 0.5rem;
    @media only screen and (min-width: 768px){
      padding: 3rem;
      top: 50%;
    }
`;

const Title = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const Logos = styled.div`
  position: absolute;
  top: 15%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 10vw;
  height: 20vh;
  min-width: 80px;
  @media only screen and (min-width: 1141px){
    width: 8vw;
    height: 20vh;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
`;

function useQueryEmail() {
  const { search } = useLocation();
  return new URLSearchParams(search).get("email") || "";
}

function ResetPassword() {
  const { token } = useParams();
  const email = useQueryEmail();
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const ResetPasswordSchema = Yup.object().shape({
    new_password: Yup.string()
      .matches(
        strongPasswordPattern,
        "Minimal 12 karakter, kombinasi huruf besar, huruf kecil, angka, dan simbol."
      )
      .required("Wajib diisi"),
    confirm_password: Yup.string()
      .required("Wajib diisi")
      .oneOf([Yup.ref("new_password"), null], "Konfirmasi tidak cocok dengan kata sandi baru"),
  });

  const formik = useFormik({
    initialValues: { new_password: "", confirm_password: "" },
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      resetPassword(token, email, values.new_password, values.confirm_password)
        .then(() => {
          setLoading(false);
          toast.success("Kata sandi berhasil diperbarui. Silakan login.");
          history.push("/auth/login");
        })
        .catch((err) => {
          setLoading(false);
          setSubmitting(false);
          setStatus(
            err?.response?.data?.error ||
              "Tautan reset tidak valid atau sudah kedaluwarsa."
          );
        });
    },
  });

  return (
    <Wrapper>
      <Logos>
        <img src={`${toAbsoluteUrl("/media/logos/mynet.png")}`} alt="MYNET" />
      </Logos>
      <Title>
        <h4>Sistem Informasi Mynet Terpadu</h4>
      </Title>
      <LoginWrapper>
        <h1>Buat Kata Sandi Baru</h1>
        <form className="form row" onSubmit={formik.handleSubmit}>
          {formik.status && (
            <div className="col-12 mb-5 alert alert-custom alert-light-danger">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <PasswordInput
              className="form-control h-auto text-white bg-white-o-5"
              placeholder="Kata Sandi Baru"
              name="new_password"
              {...formik.getFieldProps("new_password")}
            />
            {formik.touched.new_password && formik.errors.new_password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.new_password}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <PasswordStrengthMeter value={formik.values.new_password} />
          </div>
          <div className="form-group col-md-12 col-sm-12 col-xs-12">
            <PasswordInput
              className="form-control h-auto text-white bg-white-o-5"
              placeholder="Konfirmasi Kata Sandi"
              name="confirm_password"
              {...formik.getFieldProps("confirm_password")}
            />
            {formik.touched.confirm_password && formik.errors.confirm_password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.confirm_password}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group col-6">
            <Link to="/auth/login" className="btn btn-warning btn-block">
              Batal
            </Link>
          </div>
          <div className="form-group col-6">
            <button
              type="submit"
              className="btn btn-success btn-block"
              disabled={formik.isSubmitting}
            >
              <span>Simpan</span>
              {loading && <span className="ml-3 spinner spinner-white"></span>}
            </button>
          </div>
        </form>
      </LoginWrapper>
    </Wrapper>
  );
}

export default ResetPassword;
